import path from "path-browserify";
import {
  AlertSocket,
  AlertToken,
  IAlertMonitor,
  Reminder,
} from "../redux/alerts/index";
import { RepeatInclude } from "../redux/repeatAlert";
import { ResidentActivityType } from "../redux/residentActivityPlan";
interface ISoundmanager {
  // playSound(audioPath: soundPath, delay: number, fromPosition?: number, muted?: boolean): Promise<void>;
  playSounds(
    delay: number,
    fromPosition?: number,
    muted?: boolean
  ): Promise<void>;
}

export type soundPath = {
  folderPath: string;
  locale: string;
  soundName: string;
};
export type oneNotificationQueue = {
  paths: soundPath[];
  id: string;
};
export default class SoundManager implements ISoundmanager {
  constructor() {
    this.playSounds = this.playSounds.bind(this);
  }

  private static _instance: SoundManager = undefined;
  private _currentAudio: HTMLMediaElement = new Audio();
  private _currentAudioStack: oneNotificationQueue[] = [];
  private _currentNotificationQueue: oneNotificationQueue;
  private _isPlaying = false;

  static get instance(): SoundManager {
    this._instance || (this._instance = new SoundManager());
    return this._instance;
  }

  public stop(): void {
    if (this._currentAudio) {
      this._currentAudio.pause();
      this._currentAudioStack = [];
      this._currentNotificationQueue = {
        paths: [],
        id: "",
      };
      this._isPlaying = false;
    }
  }

  public get currentTime(): number {
    if (this._currentAudio) return this._currentAudio.currentTime;

    return 0;
  }

  // public playSound(audioPath: soundPath, delay = 0, fromPosition = 0, muted = false): Promise<void> {
  //     return this.playSounds([audioPath], delay, fromPosition, muted);
  // }

  public addSoundToQueueAndPlay(
    soundPath: oneNotificationQueue,
    delay = 0,
    fromPosition = 0,
    muted = false
  ): void {
    this._currentAudioStack.push(soundPath);
    // console.log(this._currentAudioStack.length + ' ' + soundPath.soundName);
    if (!this._isPlaying) {
      this.playSounds(delay, fromPosition, muted);
    }
  }

  public playSounds(
    delay: number,
    fromPosition = 0,
    muted = false
  ): Promise<void> {
    this._isPlaying = true;
    const promise = new Promise((resolve, reject) => {
      if (
        this._currentAudioStack === undefined ||
        this._currentAudioStack.length === 0
      ) {
        reject();
        return;
      }
      this._currentNotificationQueue = this._currentAudioStack[0];
      const nextAudioPath = this._currentNotificationQueue.paths.shift();
      const scr =
        nextAudioPath.folderPath +
        nextAudioPath.locale +
        nextAudioPath.soundName;
      const onError = () => {
        const scr = nextAudioPath.folderPath + "en" + nextAudioPath.soundName;
        if (nextAudioPath !== undefined) {
          this._currentAudio.src = scr;
          setTimeout(() => {
            if (this._currentAudio)
              this._currentAudio
                .play()
                .then()
                .catch((error) => {
                  reject(error);
                });
          }, delay);
        }
      };

      const onStartNext = () => {
        if (
          this._currentAudioStack.length === 0 &&
          this._currentNotificationQueue.paths.length === 0
        ) {
          resolve(undefined);
        } else {
          // console.log('_currentAudioStack Promise', this._currentAudioStack.length);
          if (
            this._currentAudioStack.indexOf(this._currentNotificationQueue) ===
            -1 //one removed
          ) {
            //go to next rem/alert
            this._currentNotificationQueue = this._currentAudioStack[0];
          } else if (this._currentNotificationQueue.paths.length === 0) {
            // this one last in queue
            this._currentAudioStack.shift();
            this._currentNotificationQueue = this._currentAudioStack[0];
          }
          if (!this._currentNotificationQueue) {
            resolve(undefined);
            this.stop();
            return;
          }
          const nextAudioPath = this._currentNotificationQueue.paths.shift();
          const scr =
            nextAudioPath.folderPath +
            nextAudioPath.locale +
            nextAudioPath.soundName;

          if (nextAudioPath !== undefined) {
            this._currentAudio.src = scr;
            setTimeout(() => {
              if (this._currentAudio)
                this._currentAudio
                  .play()
                  .then()
                  .catch((error) => {
                    reject(error);
                  });
            }, delay);
          } else this.stop();
        }
      };

      this._currentAudio.src = scr;
      this._currentAudio.muted = muted;
      this._currentAudio.onended = onStartNext;
      this._currentAudio.onerror = onError;
      this._currentAudio.autoplay = true;
      this._currentAudio.currentTime = fromPosition;
      // _this._currentAudio.onabort = onAbort;
      setTimeout(() => {
        if (this._currentAudio) {
          this._currentAudio.play().catch((error) => {
            this._isPlaying = false;
            console.log("playing audio catch");
            reject(error);
          });
        }
      }, delay);
    })
      .then(() => this.stop())
      .catch((e) => {
        console.log("whole sound playing audio catch");
      });
    return promise;
  }
  public clearNotification(
    reminder: AlertSocket | Reminder | IAlertMonitor,
    type: "Reminder" | "Alert",
    narrowType: AlertToken | ResidentActivityType,
    residentId: string,
    userId: string
  ): void {
    if (this._currentAudioStack.length) {
      const copy = this._currentAudioStack.concat();
      const ind = copy.findIndex(
        (el) =>
          el.id ===
          [
            type === "Reminder" ? reminder.lastUpdate : "",
            type,
            narrowType,
            residentId,
            userId ? userId : "",
          ].join("")
      );
      if (ind !== -1) {
        copy.splice(ind, 1);
        this._currentAudioStack = copy;
        // console.log('_currentAudioStack CLEAR', this._currentAudioStack.length);
      }
    }
  }
}

export const playNotificationWithRoom = (
  notif: AlertSocket | Reminder | IAlertMonitor,
  soundName: string,
  language: string,
  count: number,
  includes: RepeatInclude[],

  type: "Reminder" | "Alert",
  narrowType: AlertToken | ResidentActivityType,
  residentId: string,
  userId: string
): void => {
  let playQueuee: soundPath[] = [];
  const separator = path.sep || "/";
  if (soundName) {
    playQueuee.push({
      folderPath: ".." + separator + "sounds" + separator,
      locale: language,
      soundName: separator + soundName,
    });
  }
  if (
    includes.indexOf(RepeatInclude.ROOM) !== -1 &&
    notif["room"] &&
    notif.room !== null &&
    notif.room !== ""
  ) {
    playQueuee.push({
      folderPath: ".." + separator + "sounds" + separator,
      locale: language,
      soundName: separator + "Room.mp3",
    });
    notif.room.split("").map((el) => {
      playQueuee.push({
        folderPath: ".." + separator + "sounds" + separator,
        locale: language,
        soundName: separator + el + ".mp3",
      });
      return null;
    });
  }
  if (
    includes.indexOf(RepeatInclude.BED) !== -1 &&
    notif["bed"] &&
    notif.bed !== null &&
    notif.bed !== ""
  ) {
    playQueuee.push({
      folderPath: ".." + separator + "sounds" + separator,
      locale: language,
      soundName: separator + "Bed.mp3",
    });
    notif.bed.split("").map((el) => {
      if (isNaN(parseInt(el)))
        //english letter
        playQueuee.push({
          folderPath: ".." + separator + "sounds" + separator,
          locale: "en",
          soundName: separator + el + ".mp3",
        });
      else
        playQueuee.push({
          folderPath: ".." + separator + "sounds" + separator,
          locale: language,
          soundName: separator + el + ".mp3",
        });
      return null;
    });
  }
  if (count !== undefined) {
    const currentQueue = playQueuee.concat();
    for (let i = 0; i < count - 1; i++) {
      playQueuee = playQueuee.concat(currentQueue);
    }
  }

  SoundManager.instance.addSoundToQueueAndPlay({
    id: [
      type === "Reminder" ? notif.lastUpdate : "",
      type,
      narrowType,
      residentId,
      userId ? userId : "",
    ].join(""),
    paths: playQueuee,
  });
};
